<template>
  <div>
    <van-tabbar v-model="active" @change="onChange" active-color="#F79045" style="transition:bottom 1s;
	-webkit-transition:bottom 1s;" :style="{bottom:footerType ? 0 : '-50px'}">
      <van-tabbar-item>
        <span >首页</span>
        <template #icon="props">
          <img class="iconImg" :src="props.active ? homeA : home" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>选课</span>
        <template #icon="props">
          <img class="iconImg" :src="props.active ? classedA : classed" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>福利</span>
        <template #icon="props">
          <img class="iconImg" :src="props.active ? fuliA : fuli" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img class="iconImg" :src="props.active ? mineA : mine" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  props:{
    footerType:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      active: 0,
      home: require("@/assets/imgs/home/home.png"),
      classed: require("@/assets/imgs/home/class.png"),
      fuli: require("@/assets/imgs/home/fuli.png"),
      mine: require("@/assets/imgs/home/mine.png"),
      homeA: require("@/assets/imgs/home/homeA.png"),
      classedA: require("@/assets/imgs/home/classA.png"),
      fuliA: require("@/assets/imgs/home/fuliA.png"),
      mineA: require("@/assets/imgs/home/mineA.png"),
    };
  },
  created() {
    this.activeChange();
  },
  methods: {
    onChange(index) {
      if (index == 0) {
        this.$router.push("index");
      } else if (index == 1) {
        this.$router.push("classification");
      } else if (index == 2) {
        this.$router.push("liveList");
      } else if (index == 3) {
        this.$router.push("mine");
      }
    },
    activeChange() {
      let to = this.$route;
      console.log(to)
      if (to.path == "/classification") {
        this.active = 1;
      } else if (to.path == "/index") {
        this.active = 0;
      } else if (to.path == "/liveList") {
        this.active = 2;
      } else if (to.path == "/mine") {
        this.active = 3;
      }
    },
  },
  watch: {
    $route(to) {
      if (to.path == "/classification") {
        this.active = 1;
      } else if (to.path == "/index") {
        this.active = 0;
      } else if (to.path == "/liveList") {
        this.active = 2;
      } else if (to.path == "/mine") {
        this.active = 3;
      }
    },
  },
};
</script>


<style scoped>
.iconImg {
  width: 30px;
  height: 30px;
}
</style>